var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 122,
    viewBox: "0 0 144 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.162 114.61C49.872 114.61 50.601 112.974 49.1214 108.848L36.5059 66.9091L133.615 8.7168",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.162 114.611C57.4725 114.611 58.9352 113.081 60.783 111.267L78.4392 93.9248L56.4154 80.5098",
    fill: "#A9C9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4128 80.5122L109.779 120.338C115.868 123.732 120.263 121.975 121.78 114.627L143.503 11.2272C145.727 2.22047 140.104 -1.86457 134.278 0.807072L6.7235 50.489C-1.9833 54.0165 -1.93254 58.9232 5.13643 61.1095L37.8698 71.4295L113.651 23.1364C117.229 20.9451 120.512 22.1232 117.817 24.5391",
    fill: "url(#paint0_linear_240_131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_131",
    x1: 61.8619,
    y1: 61.5196,
    x2: 76.2729,
    y2: 107.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tgLogo.c8ae5101123fe6f0f3e41dc692ca22df.svg";
export { ForwardRef as ReactComponent };